import { render, staticRenderFns } from "./task_detail_drawer.vue?vue&type=template&id=9fa62b56"
import script from "./task_detail_drawer.vue?vue&type=script&lang=js"
export * from "./task_detail_drawer.vue?vue&type=script&lang=js"
import style0 from "./task_detail_drawer.vue?vue&type=style&index=0&id=9fa62b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports